var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var FileUtil = /** @class */ (function () {
    function FileUtil() {
    }
    FileUtil.base64ToFile = function (base64String) {
        if (!base64String) {
            return null;
        }
        var _a = base64String.split(","), fileName = _a[0], mimeType = _a[1], data = _a[2];
        if (!fileName || !mimeType || !data) {
            throw new Error("Formato inválido. Esperado: 'file_name,mime_type,data'");
        }
        var byteCharacters = atob(data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: mimeType });
        return new File([blob], fileName, { type: mimeType });
    };
    FileUtil.fileToBase64 = function (file) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                if (!file) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function () {
                            var result = reader.result;
                            var base64Data = result.split(",")[1];
                            resolve("".concat(file.name, ",").concat(file.type, ",").concat(base64Data));
                        };
                        reader.onerror = function (event) {
                            var _a, _b;
                            var error = (_a = event.target) === null || _a === void 0 ? void 0 : _a.error;
                            var message = (_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : "Erro desconhecido ao ler o arquivo.";
                            reject(new Error("Erro ao ler o arquivo.\nDetalhes: ".concat(message)));
                        };
                    })];
            });
        });
    };
    FileUtil.downloadBase64File = function (base64String) {
        var file = this.base64ToFile(base64String);
        if (!file)
            return;
        var blobUrl = URL.createObjectURL(file);
        var link = document.createElement("a");
        link.href = blobUrl;
        link.download = file.name;
        link.click();
        URL.revokeObjectURL(blobUrl);
    };
    FileUtil.parseFileBase64 = function (base64String) {
        var parts = base64String.split(",");
        // Verifica se temos ao menos três partes:
        //  - Nome do arquivo
        //  - Tipo (MIME)
        //  - Dados do base64
        if (parts.length < 3) {
            throw new Error("Formato inválido. Esperado: 'nome,tipo,dados'");
        }
        var fileName = parts[0];
        var mimeType = parts[1];
        var data = parts.slice(2).join(",");
        var fileUrl = "".concat(mimeType, ",").concat(data);
        return { fileName: fileName, mimeType: mimeType, data: data, fileUrl: fileUrl };
    };
    return FileUtil;
}());
export { FileUtil };
